module.exports = __webpack_public_path__ + "img/spin_btn.e8482e7d.png";